<div [formGroup]="form">
  <mat-checkbox formControlName="enableDigest">
    <label class="text-header-blue" rtI18n>Enable Post Communication Digest</label>
  </mat-checkbox>
  @if (form.get('enableDigest')?.value) {
    <div style="margin-top: 16px">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label rtI18n>Post Communication Digest Time</mat-label>
        <input matInput
               [matTimepicker]="digestTimePicker"
               formControlName="digestTimeDate"
               readonly />
        <mat-timepicker-toggle matIconSuffix [for]="digestTimePicker"></mat-timepicker-toggle>
        <mat-timepicker #digestTimePicker></mat-timepicker>
        @if (form.get('digestTimeDate')?.hasError('required') && form.get('digestTimeDate')?.touched) {
          <mat-error rtI18n>Digest time is required</mat-error>
        }
      </mat-form-field>
    </div>
  }
  <div class="d-flex align-items-center gap-2 mb-2" style="padding-top: 8px;">
    <i class="icon-info icon-text-blue" style="width: 16px; height: 16px; flex-shrink: 0;"></i>
    <div class="text-text-blue" style="font-size: 12px">
      <i rtI18n>
        Communication digest consolidates non-time sensitive posts to a set time (i.e., consolidate all
        posts until 5 p.m.). All communications will be sent at the specified time.
      </i>
    </div>
  </div>
</div>
